import type * as Types from "../../schema.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type FilesEuerQueryVariables = Types.Exact<{
  email: Types.Scalars["String"];
}>;

export type FilesEuerQuery = { __typename?: "Query"; filesEuer: boolean };

export const FilesEuerDocument = gql`
  query filesEuer($email: String!) {
    filesEuer(email: $email)
  }
`;

/**
 * __useFilesEuerQuery__
 *
 * To run a query within a React component, call `useFilesEuerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilesEuerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilesEuerQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useFilesEuerQuery(
  baseOptions: Apollo.QueryHookOptions<FilesEuerQuery, FilesEuerQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FilesEuerQuery, FilesEuerQueryVariables>(
    FilesEuerDocument,
    options
  );
}
export function useFilesEuerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FilesEuerQuery,
    FilesEuerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FilesEuerQuery, FilesEuerQueryVariables>(
    FilesEuerDocument,
    options
  );
}
export type FilesEuerQueryHookResult = ReturnType<typeof useFilesEuerQuery>;
export type FilesEuerLazyQueryHookResult = ReturnType<
  typeof useFilesEuerLazyQuery
>;
export type FilesEuerQueryResult = Apollo.QueryResult<
  FilesEuerQuery,
  FilesEuerQueryVariables
>;
